import { httpUrl } from './httpUrl'
import { getData, ifOkToJson, post } from './index'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl3 = `${httpUrl.host}/gy-apartment`
let baseUrl85 = `${httpUrl.host}/gy-apartment`
let baseUrl86 = `${httpUrl.host}/gy-log`

let api = {
  // <!--概览-->
  // 概览 ———— 蒸汽表
  getSteamMeterDeviceOverview: `${baseUrl}/steamOverview/getSteamMeterDeviceOverview`,

  // 概览 ———— 集中器
  getSteamControlDeviceOverview: `${baseUrl}/steamOverview/getSteamControlDeviceOverview`,

  // 概览 ———— 当月蒸汽量/蒸汽费
  getCurrentMonthSteamity: `${baseUrl}/steamOverview/getCurrentMonthSteamity`,

  // 概览 ———— 蒸汽量统计
  getSteamityStatistics: `${baseUrl}/steamOverview/getSteamityStatistics`,

  // 概览 ———— 充值统计
  getSteamRechargeStatistics: `${baseUrl}/steamOverview/getStatistics`,
  // <!--概览-->

  // <!--设备管理-->
  // 设备管理 ———— 查询是否可配置欠费是否关闸
  autoOffSupport: `${baseUrl}/steamMeterDevice/autoOffSupport`,

  // 设备管理 ———— 集中器分页
  getSteamControlDevicePage: `${baseUrl}/steamControlDevice/getPage`,

  // 设备管理 ———— 集中器列表
  getSteamControlDeviceList: `${baseUrl}/steamControlDevice/getList`,

  // 设备管理 ———— 集中器详情
  getSteamControlDeviceByCode: `${baseUrl}/steamControlDevice/getByCode`,

  // 设备管理 ———— 集中器添加
  addSteamControlDevice: `${baseUrl}/steamControlDevice/add`,

  // 设备管理 ———— 集中器删除
  deleteSteamControlDeviceByCodes: `${baseUrl}/steamControlDevice/deleteByCodes`,

  // 设备管理 ———— 集中器修改
  updateSteamControlDevice: `${baseUrl}/steamControlDevice/update`,

  // 设备管理 ———— 蒸汽表分页
  getSteamMeterDevicePage: `${baseUrl}/steamMeterDevice/getPage`,

  // 设备管理 ———— 蒸汽表列表
  getSteamMeterDeviceList: `${baseUrl}/steamMeterDevice/getList`,

  // 设备管理 ———— 蒸汽表详情
  getSteamMeterDeviceByCode: `${baseUrl}/steamMeterDevice/getByCode`,

  // 设备管理 ———— 蒸汽表添加
  addSteamMeterDevice: `${baseUrl}/steamMeterDevice/add`,

  // 设备管理 ———— 蒸汽表删除
  deleteSteamMeterDeviceByCodes: `${baseUrl}/steamMeterDevice/deleteByCodes`,

  // 设备管理 ———— 蒸汽表修改
  updateSteamMeterDevice: `${baseUrl}/steamMeterDevice/update`,

  // 设备管理 ———— 手动开关
  updatePowerOnOrOff: `${baseUrl}/steamMeterDevice/updatePowerOnOrOff`,

  // 设备管理 ———— 导出蒸汽表
  exportSteamMeterDevice: `${baseUrl}/steamMeterDevice/export`,

  // 设备管理 ———— 历史蒸汽量
  steamSupply: `${baseUrl}/steamSupply/getPage`,
  // <!--设备管理-->

  // <!--蒸汽配置-->
  // 蒸汽配置 ———— 收费配置
  getSteamPayConfig: `${baseUrl}/steamPayConfig/get`,

  // 蒸汽配置 ———— 修改收费配置
  updateSteamPayConfig: `${baseUrl}/steamPayConfig/update`,

  // 蒸汽配置 ———— 场景分页
  getSteamScenePage: `${baseUrl}/steamScene/getPage`,

  // 蒸汽配置 ———— 场景列表
  getSteamSceneList: `${baseUrl}/steamScene/getList`,

  // 蒸汽配置 ———— 场景添加
  addSteamScene: `${baseUrl}/steamScene/add`,

  // 蒸汽配置 ———— 场景详情
  getSteamSceneByCode: `${baseUrl}/steamScene/getByCode`,

  // 蒸汽配置 ———— 场景修改
  updateSteamScene: `${baseUrl}/steamScene/update`,

  // 蒸汽配置 ———— 场景删除
  deleteSteamSceneByCodes: `${baseUrl}/steamScene/deleteByCodes`,
  // <!--蒸汽配置-->

  // <!--蒸汽统计-->
  // 蒸汽统计 ———— 按蒸汽表统计查询
  getSteamBillMeterPage: `${baseUrl}/steamBillMeter/getPage`,

  // 蒸汽统计 ———— 按蒸汽表统计导出
  exportSteamBillMeter: `${baseUrl}/steamBillMeter/export`,

  // 蒸汽统计 ———— 按住户统计查询
  getSteamBillEnterprisePage: `${baseUrl}/steamBillEnterprise/getPage`,

  // 蒸汽统计 ———— 按住户统计导出
  exportSteamBillEnterprise: `${baseUrl}/steamBillEnterprise/export`,
  // <!--蒸汽统计-->

  // <!--余额管理-->
  // 余额管理 ———— 分页
  getSteamRentMoneyPage: `${baseUrl}/steamRentMoney/getPage`,
  // <!--余额管理-->

  // <!--充值记录-->
  // 充值记录 ———— 分页
  getSteamConsumptionRecordPage: `${baseUrl}/steamConsumptionRecord/getPage`,
  // <!--充值记录-->

  // <!--结算记录-->
  // 结算记录 ———— 分页
  getSteamSettlementPage: `${baseUrl}/steamSettlement/getPage`,
  // <!--结算记录-->

  // <!--设备状态日志-->
  // 设备状态日志 ———— 分页
  getSteamDeviceStatusPage: `${baseUrl}/steamDeviceStatus/getPage`,

  // 设备状态日志 ———— 导出
  exportSteamDeviceStatus: `${baseUrl}/steamDeviceStatus/export`,
  // <!--设备状态日志-->

  // 获取园区责任人
  getResponsiblePersonList: `${baseUrl85}/person/getResponsiblePersonList`,

  // 获取楼栋列表
  getBuildingList: `${baseUrl85}/building/getBuildingList`,

  //获取蒸汽费结算配置
  getSteamSettlementConfig: `${baseUrl}/steamSettlementConfig/get`,

  //蒸汽费结算配置保存
  saveSteamSettlementConfig: `${baseUrl}/steamSettlementConfig/save`,

  //级别蒸汽量统计
  getSteamLevelStatistics: `${baseUrl}/steamOverview/getStatistics`,

  //场景蒸汽量统计
  getSteamStatistics: `${baseUrl}/steamOverview/getSceneStatistics`,

  // 蒸汽表最新读数—分页
  getSteamRealRecordPage: `${baseUrl}/steamRealRecord/getPge`,

  // 蒸汽表最新读数—导出
  exportSteamRealRecord: `${baseUrl}/steamRealRecord/export`,

  // 生成蒸汽表标签
  generateCipherText: `${baseUrl}/codeScanning/generateCipherText`,

  // 导出蒸汽表标签
  exportCodeScanning: `${baseUrl}/codeScanning/export`,

  // 读表器管理—分页
  getSteamReaderDevicePage: `${baseUrl}/steamReaderDevice/getPage`,

  //操作日志
  getsteamLogPage: `${baseUrl86}/log/getPage`,
}

export { api }



// WEBPACK FOOTER //
// ./src/view/api/SteamManagement.js